<template>
  <div
    class="modal fade dq-modal"
    id="employee_bulk_resend_password_modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
    data-bs-keyboard="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content dq-modal-card">
        <div class="modal-body text-center">
          <div class="mail-badge">
            <i class="ti ti-mail-forward"></i>
          </div>
          <h4 class="mb-2">Resend set-password emails?</h4>
          <p class="text-muted mb-3">
            <b>{{ count }}</b>
            {{ count === 1 ? "employee" : "employees" }}
            will get a fresh set-password link.
            The emails go out a few per minute, not all at once.
          </p>
          <div class="mail-note">
            <i class="ti ti-info-circle me-1"></i>
            People without portal access are left out. Their login is not created by this action.
          </div>
          <div class="d-flex justify-content-center flex-wrap gap-2 mt-4">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" :disabled="submitting">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" :disabled="submitting" @click="confirm">
              <span v-if="submitting" class="spinner-border spinner-border-sm me-1"></span>
              Queue emails
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Modal } from "bootstrap";

const emit = defineEmits(["confirmed"]);

const submitting = ref(false);
const ids = ref([]);
const count = ref(0);
let modalInstance = null;

function getModal() {
  const el = document.getElementById("employee_bulk_resend_password_modal");
  if (!el) return null;
  modalInstance = Modal.getOrCreateInstance(el, { backdrop: false, keyboard: true });
  return modalInstance;
}

function open(employeeIds) {
  const next = (employeeIds || []).map((id) => Number(id)).filter(Boolean);
  if (!next.length) return;
  ids.value = next;
  count.value = next.length;
  submitting.value = false;
  getModal()?.show();
}

function hide() {
  modalInstance?.hide();
}

function confirm() {
  if (submitting.value || !ids.value.length) return;
  emit("confirmed", { ids: [...ids.value] });
}

function setSubmitting(value) {
  submitting.value = !!value;
}

defineExpose({ open, hide, setSubmitting });
</script>

<style scoped>
.mail-badge {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 26px;
  background: rgba(59, 130, 246, 0.12);
  color: rgb(29, 78, 216);
}
.mail-note {
  background: rgba(59, 130, 246, 0.08);
  color: rgb(30, 64, 175);
  border-radius: 12px;
  padding: 10px 12px;
  text-align: left;
  font-size: 13px;
}
</style>
